import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '@/components/ui/card';
const ProductDetail = () => {
  const {
    id
  } = useParams();
  return <div className="space-y-6" data-id="element-1649">
      <h1 className="text-2xl font-bold" data-id="element-1650">Product Detail</h1>
      <Card className="p-6" data-id="element-1651">
        <p className="text-muted-foreground" data-id="element-1652">
          Product {id} details coming soon
        </p>
      </Card>
    </div>;
};
export default ProductDetail;